import React from 'react';
import {FormControl, InputLabel, MenuItem, Select, Stack, SxProps, Typography} from "@mui/material"
import {AnyCustomModelJson} from "../../api/json/CustomModelJson"

interface CustomModelSelectProps {
    models: AnyCustomModelJson[]
    selected?: AnyCustomModelJson
    onSelect: (customModel: AnyCustomModelJson) => void
    sx: SxProps
}

function CustomModelSelect({models, selected, onSelect, sx}: CustomModelSelectProps) {
    return (
        <FormControl sx={sx}>
            <InputLabel id="custom-model-select-label">Custom Model</InputLabel>
            <Select
                labelId="custom-model-select-label"
                value={selected?.id ?? ""}
                label="Custom Model"
                onChange={(e) => {
                    const model = models.find(customModel => customModel.id === e.target.value)!
                    onSelect(model)
                }}
            >
                {models.map(model => {
                    const score = model.qualityCheck.completed && model.qualityCheck.stats
                        ? model.qualityCheck.stats.score
                        : null
                    const caption = [
                        score != null ? `Score ${Math.round(score * 10) / 10}%` : null,
                        model.completed ? `Trained ${new Date(model.completed).toLocaleDateString(undefined, {month: "short", day: "numeric", year: "numeric"})}` : null,
                    ].filter(Boolean).join("  ·  ")
                    return (
                        <MenuItem key={model.id} value={model.id}>
                            <Stack>
                                <Typography>{model.name}</Typography>
                                {caption &&
                                    <Typography variant="caption" color="text.secondary">{caption}</Typography>
                                }
                            </Stack>
                        </MenuItem>
                    )
                })}
            </Select>
        </FormControl>
    );
}

export default CustomModelSelect;